import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const PhoneLayout = ({ children }:any) => {
    return (
        <div className="phone-layout-desktop">
            <div className="phone-layout-container">
                {children}
            </div>
        </div>
    );
};

root.render(
  <Provider store={store}>
      <BrowserRouter>
          <PhoneLayout>
              <App/>
          </PhoneLayout>
      </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
